import BaseMap from '../../BaseMap.jsx'
import useReadMap from './useReadMap.mjs'

export default function ShareMap({id, ...props}) {
    const readMap = useReadMap(id)

    return (
        <BaseMap
            readMap={readMap}
            {...props}
        />
    )
}
